import React from 'react';
import Wizard from './Wizard'
import Form from './Form'

/*
let formData = [[
  {
    id: 'name',
    type:'text',
    label: 'Наименование',
    placeholder: 'Наименование организации',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'inn',
    type:'text',
    label: 'ИНН',
    placeholder: 'ИНН организации',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'agree',
    type:'checkbox',
    label: 'Согласись с этим',
    value: false
  }],
  [{
    id: 'fullName',
    type:'text',
    label: 'Контактное лицо',
    placeholder: 'Контактное лицо',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'email',
    type:'text',
    label: 'Контактный email',
    placeholder: 'Контактный email',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  }],
  [{
    id: 'phone',
    type:'text',
    label: 'Контактный телефон',
    placeholder: 'Контактный телефон',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'plan',
    type:'select',
    label: 'Выберите тариф',
    options: [
               {label: 'Разовый', value: 'Разовый'},
               {label: 'Эконом', value: 'Эконом'},
               {label: 'Оптимальный', value: 'Оптимальный'},
               {label: 'Комфортный', value: 'Комфортный'}
             ],
    value: 'Комфортный',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  }],
  [{
    id: 'clientAccount',
    type:'text',
    label: 'Расчетный счет',
    placeholder: 'Расчетный счет',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'bankAccount',
    type:'text',
    label: 'Кор.Счет',
    placeholder: 'Кор.Счет',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  }],
  [{
    id: 'bik',
    type:'text',
    label: 'БИК',
    placeholder: 'БИК',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  },
  {
    id: 'bankName',
    type:'text',
    label: 'Наименование банка',
    placeholder: 'Наименование банка',
    rules: [{rule: 'nonEmpty', message: 'Пожалуйста, заполните это поле'}]
  }
]]

function previousButton({onClick}) {
  return <a className="button is-large is-danger" onClick={onClick}>Назад</a>
}

function nextButton({onClick}) {
  return <a className="button is-fullwidth is-large is-success" onClick={onClick}>Продолжить</a>
}

function finishButton({onClick}) {
  return <a className="button is-fullwidth is-large is-success" onClick={onClick}>Отправить</a>
}


const typeRender = {
  text: {component: Text},
  select: {component: Select},
  checkbox: {component: Checkbox, onChange: checked},
  previousButton: {component: previousButton},
  nextButton: {component: nextButton},
  finishButton: {component: finishButton}
}

function sendData(data) {
  console.log(data)
  //window.location.replace('http://ed25.ru/forms/#/congrats')
}
*/

export {Wizard, Form}



// WEBPACK FOOTER //
// ./src/formWizard/index.js